<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header">
                        </slot>
                    </div>
                    <div class="modal-body">
                        <slot name="body">
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button class="modal-default-button" @click="$emit('close')">
                                Проверить
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

import buttonRed from '@/components/ui/buttons/button_red';

export default {
  components: {
    buttonRed,
  },
};
</script>

<style lang="sass" scoped>
.modal-mask
  position: fixed
  z-index: 9998
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, 0.5)
  display: table
  transition: opacity 0.3s ease


.modal-wrapper
  display: table-cell
  vertical-align: middle


.modal-container
  width: 500px
  height: 320px
  margin: 0px auto
  padding: 30px
  background-color: #fff
  border-radius: 2px
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33)
  transition: all 0.3s ease
  font-family: Helvetica, Arial, sans-serif


.modal-header h3
  margin-top: 0
  color: #42b983


.modal-body
  margin: 20px 0


.modal-default-button
  float: right

.modal-enter
  opacity: 0


.modal-leave-active
  opacity: 0

.modal-default-button
  color: #fff
  padding: 15px 25px
  background-color: #E4183E
  opacity: 1
  transition: opacity 0.3s ease-in-out

  &:hover
    opacity: 0.75

.modal-enter .modal-container,
.modal-leave-active .modal-container
  -webkit-transform: scale(1.1)
  transform: scale(1.1)

</style>
